import { animated, config, useSpring } from "@react-spring/web";
import cn from "classnames";
import type { ComponentPropsWithoutRef } from "react";
import styles from "./Progress.module.css";

interface ProgressProps extends ComponentPropsWithoutRef<"div"> {
	/**
	 * 0 - 100
	 */
	value: number | undefined;
}

export function Progress(props: ProgressProps) {
	const { value, className, ...rest } = props;
	const spring = useSpring({
		width: `${value ?? 100}%`,
		config: config.stiff,
	});

	return (
		<div className={cn(styles.container, className)} {...rest}>
			<animated.div
				className={cn(styles.bar, {
					[styles.indeterminate]: value === undefined,
				})}
				style={spring}
			/>
		</div>
	);
}
